import { useQuery } from "react-query"
import UserService from "~services/UserService"
import { ASSIGNEE_TYPE } from "~constants/proofOfOwnership"

// Turns a POO finalizer (who delivered the terminal verdict) into a human label
// for the history view:
//   - null when there's no finalizer (non-terminal / legacy record)
//   - "System · <id>" for a SYSTEM finalizer (the id is already readable, e.g.
//     "auto-expirer")
//   - the operator's email for a USER finalizer (ids are user hashids, resolved
//     by id; falls back to `@hashid` while the lookup is in flight or fails)
//
// Unlike useOperatorLabel, this never suppresses the current operator — a history
// row should always say who finalized it, including yourself.
const useFinalizerLabel = (
  type?: ASSIGNEE_TYPE | string | null,
  id?: string | null,
): string | null => {
  const isUser = type === ASSIGNEE_TYPE.USER && !!id

  const { data: operator } = useQuery(
    ["operator-user", id],
    () => UserService.getUserById(id!, false),
    { enabled: isUser, staleTime: 5 * 60 * 1000 },
  )

  if (!type || !id) return null
  if (type === ASSIGNEE_TYPE.SYSTEM) return `System · ${id}`
  return operator?.email || `@${id}`
}

export default useFinalizerLabel
